export default __webpack_public_path__ + "static/media/Animals18.b5c0bad0.jpg";